import React, { Component } from "react";
import { Button } from "reactstrap";

import moment from "moment";
import { Collapse } from "reactstrap";

function dateFormatter(cell) {
    if (!cell) {
      return "";
    }
    return `${
      moment(cell).format("YYYY-MM-DD")
        ? moment(cell).format("YYYY-MM-DD")
        : moment(cell).format("YYYY-MM-DD")
    }`;
  }

export class MSVDetailsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSaveDataSection: this.props.claimProcess ? true : false,
            isOpen :true
        };
    }

    checkData = (data) => {
        if (!data) {
            return "Not Available";
        }
        return data;
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.claimProcess !== this.props.claimProcess) {
            this.setState({
                enableSaveDataSection: this.props.claimProcess === true
            })

        }
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    saveData = (flag) => {
        if (flag === "yes") {
            this.props.saveMSVData();
        }
        this.setState({
            enableSaveDataSection: false
        })
    }

    render() {
        let data = this.props.data;
        return (
            <div>
                <div className="detailsSectionBoxWrapper" >
                    <div className="collapsible-box" onClick={this.toggle}>
                        <h5 className="">Membership Status Validation (MSV) Response Details - ({data && this.checkData(dateFormatter(data.file_date))})</h5>
                        {this.state.isOpen ? (
                        <i className="fa fa-angle-up" aria-hidden="true"></i>
                        ) : (
                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                        )}
                    </div>
                    <Collapse isOpen={this.state.isOpen}>
                    <hr />
                    <div className="row mt-3">


                    {data && data.result_status && (
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <h6>{data.result_status === "Valid"?
                                "The membership is valid and active.":
                                "The membership is Invalid."}</h6>
                            </div>
                        </div>
                    </div>)}

                        <div className="col-md-6">

                            <div className="row">
                                <div className="col-md-6">
                                    <label>Result Status</label> :{" "}
                                </div>
                                <div className="col-md-6">
                                    {data && this.checkData(data.result_status)}
                                </div>
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Result Description</label> :{" "}
                                </div>
                                <div className="col-md-6">
                                    {data && this.checkData(data.result_description)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Validation Method</label> :{" "}
                                </div>
                                <div className="col-md-6">
                                    {data && this.checkData(data.validation_method)}
                                </div>
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>File Date </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(dateFormatter(data.file_date))}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Patient Full Name </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.patient_name)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Patient Surname </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.patient_surname)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Patient Initials </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.patient_initials)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Patient DOB </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(dateFormatter(data.dob))}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>ID/PASSPORT NO. </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.passport_number)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Member Full Name </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.member_fullname)}
                                </div>
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Member Surname </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.member_surname)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Medical Scheme Name </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.medical_scheme_name)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Scheme Plan Option </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.medical_scheme_plan_option_name)}
                                </div>
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Medical Scheme Response </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.mediclaim_scheme_response)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Membership Number </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.membership_number)}
                                </div>
                            </div>
                        </div>

                        
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Dependent Code </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.patient_dependant_code)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Effective Date </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(dateFormatter(data.medical_scheme_effective_date))}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Termination Date </label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(dateFormatter(data.medical_termination_date))}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Disclaimer</label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.disclaimer)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Comments</label> :{" "}
                                </div>

                                <div className="col-md-6">
                                    {data && this.checkData(data.comments)}
                                </div>
                            </div>
                        </div>



                        {this.state.enableSaveDataSection && data && data.result_status === "Valid" && (
                            <div className="col-md-12 mt-3">
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Do you want to update patient details to below section based on above MSV response?</label>
                                    </div>
                                    <div className="col-md-12">
                                        <div>
                                            <Button
                                                className="ttm-primary-btn mr-3"
                                                type="button"
                                                onClick={() => this.saveData("yes")}
                                            >
                                                Yes
                                                   </Button>

                                            <Button
                                                className="ttm-primary-btn mr-3"
                                                type="button"
                                                onClick={() => this.saveData("no")}
                                            >
                                                No
                                                   </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>)}
                    </div>
                    </Collapse>
                </div>
            </div>
        );
    }



}


export default MSVDetailsSection;